module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABICAYAAAAqPKG2AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADQSURBVHgB7dtBEcJADEDRLAqQgARwghUUIQFwUAcgAQl1UHYpFxRAMu/NpO0905lcfotuWZZdf5377PtsgyyufU6ttWf7LPEeFpjV3OcwFnnpH8cgs2kscgmymzex/prkth2LfATZ3Rw7+b2Pnc04XcdHrKcseYwFTjEu1nWHAAAAAAAAAAAAAPBzbTz0kWnpIwvRRxaijyxCH1mEPrIIfWQB+sjk9JEAAAAAAAAAAAAA/B19ZG76yEL0kYXoI4vQRxahjyxCH1mAPjK5rz7yBW6TYuPHOywHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/header/Menu_btn.png
// module id = 343
// module chunks = 0